// @flow

import * as React from 'react';
import * as icons from 'app/common/icons';
import Tooltip from '@mui/material/Tooltip';

type Props = {
  icon: string,
  text: string
};

class ToolTipIcon extends React.PureComponent<Props> {
  render() {
    const { icon, text } = this.props;
    const Icon = icons[icon];

    return (
      <Tooltip title={text}>
        <span style={{ fontSize: '1em' }}>
          <Icon fontSize="inherit" style={{ opacity: 0.4 }} />
        </span>
      </Tooltip>
    );
  }
}

export default ToolTipIcon;
